/// <reference types="vite-plugin-svgr/client" />
import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import faAffordable from "@/assets/icons/faAffordable.svg";
import faEnergyEfficient from "@/assets/icons/faEnergyEfficient.svg";
import faLongLasting from "@/assets/icons/faLongLasting.svg";
import faSpeedyConstruction from "@/assets/icons/faSpeedyConstruction.svg";
import faSustainableHome from "@/assets/icons/faSustainableHome.svg";
import { getCurrentLang } from "@/utils/Local";

import i18n from "../../i18n";

const IntroScreen: React.FC = () => {
  const { t } = i18n;
  const percentage = getCurrentLang() === "fr" ? " %" : "%";
  const reasons = [
    {
      icon: <img alt={t("Sustainable")} src={faSustainableHome} />,
      title: t("Sustainable"),
      value: `100${percentage}`,
      note: t("recycled plastic bottles"),
    },
    {
      icon: <img alt={t("Speedy Construction")} src={faSpeedyConstruction} />,
      title: t("Speedy Construction"),
      value: `10X`,
      note: t("faster"),
    },
    {
      icon: <img alt={t("Affordable")} src={faAffordable} />,
      title: t("Affordable"),
      value: `35${percentage}`,
      note: t("less expensive"),
    },
    {
      icon: <img alt={t("Long-Lasting")} src={faLongLasting} />,
      title: t("Long-Lasting"),
      note: t("years life expectancy"),
      value: "400+",
    },
    {
      icon: <img alt={t("Energy Efficient")} src={faEnergyEfficient} />,
      title: t("Energy Efficient"),
      note: t("more energy-efficient"),
      value: `15${percentage}`,
    },
  ];

  return (
    <Container fluid className="screenContainer introContainer p-0 mt-4 mb-4">
      <Container className="flexContainer">
        <Row className="w-100">
          <Col xs={12}>
            <h2 className="text-center text-lg-start">
              {t("Why Choose PakVille")}?
            </h2>
          </Col>
        </Row>

        <div className=" horizontal-content-container">
          {reasons.map((reason) => (
            <div key={reason.title} className="pakvilleReasonContainer">
              {reason.icon}
              <h3>{reason.title}</h3>
              <p>
                <span>{reason.value}</span>&nbsp;
                <span>{reason.note}</span>
              </p>
            </div>
          ))}
        </div>
      </Container>
    </Container>
  );
};

export default IntroScreen;
